<template>
  <NotificationTooltip
    :title="buttonToolTip.buttonToolTipTitle"
    :content="content"
  />
</template>

<script setup>
import CustomisedProduct from '~/models/CustomisedProduct'
const { $tcs } = useNuxtApp()

const props = defineProps({
  customisedProduct: { type: CustomisedProduct, required: true },
})

const buttonToolTip = computed(() => {
  if (props.customisedProduct.baseProductWithToolTip) {
    return {
      buttonToolTipTitle: props.customisedProduct.product.pdpConfig.buttonToolTipTitle,
      buttonToolTipContent: props.customisedProduct.product.pdpConfig.buttonToolTipContent
    }
  } else if (props.customisedProduct.choiceWithToolTip) {
    return {
      buttonToolTipTitle: props.customisedProduct.choiceWithToolTip.buttonToolTipTitle,
      buttonToolTipContent: props.customisedProduct.choiceWithToolTip.buttonToolTipContent
    }
  }

  return null
})

const conversionRate = computed(() => {
  if (props.customisedProduct.baseProductWithToolTip) {
    return props.customisedProduct.price / props.customisedProduct.product.priceGBP
  } else if (props.customisedProduct.choiceWithToolTip) {
    return props.customisedProduct.price / props.customisedProduct.priceGBP
  }

  return 0
})

const convertedPrice = computed(() => {
  const match = buttonToolTip.value.buttonToolTipContent.match(/\{(.*?)\}/);
  const value = match ? match[1].trim() : null;

  return Math.round(value * conversionRate.value)
})

const content = computed(() => {
  let displayPrice = $tcs(convertedPrice.value)

  if(displayPrice.startsWith('$')) {
    displayPrice = '$' + displayPrice
  }

  return buttonToolTip.value.buttonToolTipContent.replace(/\{(.*?)\}/, `${displayPrice}`)
})
</script>